/**
 * Format a mood date for display.
 * @param moodDate - Date string in YYYY-MM-DD format.
 * @returns Formatted date string like "20 Aug '25".
 */
export const formatMoodDate = (moodDate: string): string => {
  const date = new Date(moodDate);
  const day = date.getDate();
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear().toString().slice(-2);
  return `${day} ${month} '${year}`;
};
